import { AxiosError } from "axios";
import { useApi } from "../hooks/useApi";
import { FormValuesContact } from "../interfaces/formContact";

const api = useApi();

export async function sendContactForm(values: FormValuesContact): Promise<{ message: string }> {
  try {
    const { data } = await api.post("contact", values);
    return data;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response) {// L'API a répondu, mais avec une erreur
        throw new Error(error.response.data.message || "Erreur lors de l'envoie du formulaire de contact");
      } else {// l'API n'a pas répondu (erreur réseau)
        throw new Error("Impossible de se connecter à l'API. Veuillez réessayer plus tard.");
      }
    }
    // Erreurs générales ou inconnues
    throw new Error("Une erreur inconnue est survenue. Veuillez réessayer plus tard.");
  }
}